import { useCallback } from "react";

import { URL_HASH_OPEN_INFRA_ASSISTANT_KEY } from "constants/urlHashKeys";
import useUrlHashTrigger from "hooks/useUrlHashTrigger";

import { AssistantPanelView } from "../Layout/types";
import useAssistantPanelStore from "../Layout/useStore";
import useAssistantPanelAnalytics from "../analytics/useAnalytics";

/**
 * Opens the panel in chat view when a `#openInfraAssistant` link asks for it — today the
 * Userflow onboarding checklist, which can't call into the app because its JavaScript action
 * needs unsafe-eval that our CSP denies.
 */
const useAssistantPanelExternalOpenTriggers = (isPanelRendered: boolean) => {
  const { trackConversationOpened } = useAssistantPanelAnalytics();

  const openInChatView = useCallback(() => {
    // isOpen is persisted, so opening it on a page without the drawer would surface later.
    if (!isPanelRendered) {
      return;
    }

    const { switchView, setIsOpen } = useAssistantPanelStore.getState();

    switchView(AssistantPanelView.CHAT);
    setIsOpen(true);
    trackConversationOpened("external_link");
  }, [isPanelRendered, trackConversationOpened]);

  useUrlHashTrigger(URL_HASH_OPEN_INFRA_ASSISTANT_KEY, openInChatView);
};

export default useAssistantPanelExternalOpenTriggers;
